import {http_client} from "@/plugins/http_client";



const getTiposPersona = async (params = {}) => 
await http_client('/api/v1/catalogos/tipo-persona', params, 'get');

export default {
    getTiposPersona,
}